import React, {useContext, useEffect, useState} from 'react'
import './style.css';
import { Grid } from '@mui/material';
import {Navigate} from 'react-router';
import LoginForm from './LoginForm';
import Busy from "../../components/Busy";
import {AppContext} from '../../context/app-context';
import {isLoggedIn} from '../../util/AccountUtils';
import {getLandingRedirectPathForUser} from '../../routing/route-utils';
import PageSEO from '../../components/seo/PageSEO';

const Login = () => {
  const { user } = useContext(AppContext);
  const [loaded, isLoaded] = useState(false);

  useEffect(() => {
    Busy.set(true);
    const timeout = setTimeout(() => {
      isLoaded(true);
      Busy.set(false);
    }, 100);
    return () => {
      clearTimeout(timeout);
      Busy.set(false);
    }
  }, []);

    if (isLoggedIn(user)) {
      return <Navigate to={getLandingRedirectPathForUser(user)} replace />
    }

    return (
        <section>
            {/* Indexable, for "SecurSpace login" searches (securspace-ui#3107). */}
            <PageSEO
                title="Log In | SecurSpace"
                description="Log in to your SecurSpace account to manage truck parking and container storage bookings, locations and gate activity."
                canonicalUrl="https://secur.space/login"
            />
            <div className="ss-auth-background" />
            <Grid className='ss-login-section-container' container direction='column' justifyContent='center' alignItems='center'>
                <Grid item className='ss-login-content-container'>
                  {loaded && <LoginForm />}
                </Grid>
            </Grid>
        </section>
    );
};

export default Login;
